import React from 'react';
import '../styles/SplashScreen.css';

const Splash   = () => {
  return (
    <div className="splash-screen">
      <div className="hammer-container">
        <div className="hammer">
          <div className="hammer-head"></div>
          <div className="hammer-handle"></div>
        </div>
      </div>
      <div className="text-container">
        <h2 className="title">Legal Trails</h2>
        <h2>“The Legal and Financial Solution Firm”</h2>
      </div>
    </div>
  );
};

export default Splash;